<script lang="ts" setup>
import type { AllNewsSectionRecord, ImageFileField } from "~~/server/graphql/datocms/generated";
import { paginationLeftButton, paginationRightButton } from "~/utils/styles";

defineProps<{ data: AllNewsSectionRecord }>();

const localePath = useLocalePath();
const { locale } = useI18n();

const pageSize = 18;
const page = ref(1);

const { data: newsData } = await useFetch("/api/cms/news", {
  query: { pageSize: pageSize, page: page, locale: locale },
  deep: true,
});

// not required, but cleaner
const itemCount = computed(() => {
  return newsData.value?._allNewsMeta?.count ?? 0;
});
</script>

<template>
  <div id="news-list" class="mb-3xl lg:mb-5xl scroll-mt-8">
    <div v-show="itemCount > 0" class="mb-lg gap-lg md:mb-3xl md:gap-md grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
      <article v-for="news in newsData?.allNews" :key="news.id">
        <NuxtLink :to="localePath({ name: 'news-slug', params: { slug: news.slug } })">
          <TeaserCard :page-id="news.id" :image="news.teaserImage as ImageFileField" :title="news.title" :text="news.teaserText" />
        </NuxtLink>
      </article>
    </div>

    <div v-show="itemCount > pageSize" class="flex justify-center">
      <UPagination v-model:page="page" :items-per-page="pageSize" :total="itemCount">
        <template #prev>
          <UTooltip text="Previous page">
            <UButton icon="i-ph-arrow-circle-left" :class="paginationLeftButton" />
          </UTooltip>
        </template>

        <template #next>
          <UTooltip text="Next page">
            <UButton icon="i-ph-arrow-circle-right" :class="paginationRightButton" />
          </UTooltip>
        </template>
      </UPagination>
    </div>
  </div>
</template>

<style scoped>

</style>
